export default "__VITE_ASSET__Dp5gofue__"